<i18n>
{
  "fr": {
    "customerProjectModal": {
      "description": "Votre projet a été enregistré. N'oubliez pas de l'enregistrer à la prochaine modification.",
      "buttons": {
        "account": "Aller dans mon espace",
        "close": "Fermer cette fenêtre"
      }
    }
  }
}
</i18n>

<script>
import BaseModal from '../BaseModal';
import Modal from '../../mixins/Modal';
import BaseBtn from '../BaseBtn';

const BASE_CLASS = 'customer-project-modal';

export default {
  name: 'CustomerProjectModal',
  components: { BaseModal, BaseBtn },
  mixins: [Modal],
  props: {
    accountUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return { BASE_CLASS };
  },
  computed: {
    isModalActive: {
      /**
       * @returns {boolean}
       */
      get() {
        return window.modalStateObservable.isCustomerProjectModalActive;
      },
      /**
       * @param {boolean} value
       */
      set(value) {
        window.modalStateObservable.isCustomerProjectModalActive = value;
      },
    },
    /**
     * @returns {Array}
     */
    modalClasses() {
      return [BASE_CLASS, `${BASE_CLASS}--'configurator'`];
    },
  },
};
</script>

<template>
  <BaseModal
    v-model="isModalActive"
    :class="modalClasses"
    white
    hide-close-button
  >
    <template #header></template>
    <img
      :class="`${BASE_CLASS}__image`"
      src="../../../../images/project/configurator.svg"
      alt="Sauvegarde du projet"
    />
    <p :class="`${BASE_CLASS}__description`">
      {{ $t(`customerProjectModal.description`) }}
    </p>
    <div :class="`${BASE_CLASS}__buttons`">
      <BaseBtn
        type="link"
        :href="accountUrl"
        :class="`${BASE_CLASS}__account-button`"
        secondary
        block
      >
        {{ $t('customerProjectModal.buttons.account') }}
      </BaseBtn>
      <BaseBtn
        type="button"
        :class="`${BASE_CLASS}__close-button`"
        block
        default
        @click="isModalActive = false"
      >
        {{ $t('customerProjectModal.buttons.close') }}
      </BaseBtn>
    </div>
  </BaseModal>
</template>

<style scoped lang="scss">
.customer-project-modal {
  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.625rem;
  }

  &__close-button,
  &__account-button {
    font-size: 1rem;
    height: 3.4375rem;
  }

  &__close-button {
    background-color: transparent;
    color: $color-arapawa;
    border: 1px solid $color-arapawa;
    text-decoration: none;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
